import { Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

export const PlusButton = ({ onClick }: { onClick: () => void }) => {
  return (
    <Button
      variant="contained"
      color={'secondary'}
      onClick={onClick}
      sx={{ boxShadow: 6, alignSelf: 'center' }}>
      <AddIcon fontSize="large" />
    </Button>
  );
};
